if (!customElements.get('accordion-component')) {
  class AccordionComponent extends HTMLElement {
    constructor() {
      super();

      this.animationDelay = null;
      this.allowOneOpened = this.hasAttribute('data-allow-one-opened');

      this.addEventListener('click', (e) => {
        const accordionButton = e.target.closest('[data-accordion-button]');

        if (!accordionButton) return;

        this.handleButtonClick(e, accordionButton);
      });
    }

    handleButtonClick(e, button) {
      e.preventDefault();

      clearTimeout(this.animationDelay);

      const accordionSection = button.parentElement;
      const isOpen = accordionSection.classList.contains('is-open');

      !isOpen ? this.open(accordionSection) : this.close(accordionSection);
    }

    open(accordionSection) {
      if (this.allowOneOpened) {
        this.closeAll();
      }

      accordionSection.setAttribute('open', '');
      setTimeout(() => {
        accordionSection.classList.add('is-open');
      });
    }

    close(accordionSection) {
      accordionSection.classList.remove('is-open');
      this.animationDelay = setTimeout(() => {
        accordionSection.removeAttribute('open');
      }, this.dataset.animationDuration || 300);
    }

    closeAll() {
      const openedSections = this.querySelectorAll('.is-open');

      openedSections.forEach((section) => this.close(section));
    }
  }

  customElements.define('accordion-component', AccordionComponent);
}
